import { NgModule } from '@angular/core';
import { FuseSelectSearchPipe } from '@fuse/pipes/select-search/select-search.pipe';

@NgModule({
    declarations: [
        FuseSelectSearchPipe
    ],
    exports     : [
        FuseSelectSearchPipe
    ]
})
export class FuseSelectSearchPipeModule
{
}
